import { motion } from 'framer-motion';
import styled from 'styled-components';

import { WidthOptions } from 'utils/sharedStrapiQueries/sharedTypes';
import { mediaDesktopLarge, mediaTablet } from 'utils/styles/responsive';

const handleWidthMedium = (width: WidthOptions) => {
  switch (width) {
    case 'full':
      return 'span 12';

    case 'threeFourth':
      return 'span 12';

    case 'half':
      return 'span 12';

    case 'quarter':
      return 'span 6';

    default:
      return 'span 6';
  }
};

const handleWidthLarge = (width: WidthOptions) => {
  switch (width) {
    case 'full':
      return 'span 13';

    case 'threeFourth':
      return 'span 9';

    case 'half':
      return 'span 6';

    case 'quarter':
      return 'span 3';

    default:
      return 'span 13';
  }
};

export interface WidthBlockWrapperProps {
  $spanWidth: WidthOptions;
}

export const WidthBlockWrapper = styled(motion.div)<WidthBlockWrapperProps>`
  grid-column: 1/-1;

  ${({ $spanWidth }) =>
    mediaTablet(`
  grid-column: ${handleWidthMedium($spanWidth)};
`)}

  ${({ $spanWidth }) =>
    mediaDesktopLarge(`
  grid-column: ${handleWidthLarge($spanWidth)};
`)}
`;
